<template>
  <div>
    <div
      :class="['coupon', { couponout: item.status != 0 }]"
      v-for="(item, index) in list"
      :key="index"
    >
      <div>
        <p class="money">
          ￥<span>{{ item.price }}</span> 满{{ item.min_price }}元可用
        </p>
        <p class="time">有效期至：{{ item.time }}</p>
      </div>
      <div class="btn" @click="clickbtn(item)">
        {{ item.status == 0 ? "立即使用" : "已过期" }}
      </div>
    </div>
  </div>
</template>

<script>
/**
@description:优惠券组件
@createTime:2021-09-23
@create:wq
*/
export default {
  name: "",
  props: ["list"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {
    clickbtn(item) {
      this.$emit("use", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.coupon {
  margin: 0.25rem auto;
  width: 7rem;
  height: 1.86rem;
  background-image: url(../../../assets/mine/coupon.png);
  background-size: 100% 100%;
  padding: 0 0.3rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .money {
    font-size: 0.28rem;
    color: #ffffff;
    span {
      font-size: 0.6rem;
      font-family: Impact;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .time {
    font-size: 0.26rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 0.2rem;
  }
  .btn {
    width: 1.4rem;
    height: 0.54rem;
    background: #ffffff;
    border-radius: 0.27rem;

    font-size: 0.24rem;
    color: #f05468;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.couponout {
  background-image: url(../../../assets/mine/couponout.png);
  .btn {
    background: #ffffff;
    color: #cccccc;
  }
}
</style>
